import React from "react";
import { AvisoPrivacidadeBody, Hr, PrivacySection, PrivacySectionContent, Title, TocLink, TocSticky } from "./styles";
import { Nav } from "react-bootstrap";

export default function LgpdAvisoPrivacidadeHome(...props) {
    return (
        <AvisoPrivacidadeBody>
            <Title>
                <h1>Aviso De Privacidade Grupo Cereal</h1>
                <Hr />
            </Title>
            <div className="container mb-5" data-bs-spy="scroll" data-bs-target=".toc-sticky" data-bs-offset="110" tabIndex="0">
                <div className="row">
                    <div className="col-lg-3 mb-4">
                        <PrivacySection>
                            <TocSticky>
                                <h4 className="mb-4">Sumário</h4>
                                <nav>
                                    <ul className="list-unstyled">
                                        <li className="mb-2">
                                            <TocLink>
                                                <a href="#glossario">1. Glossário</a>
                                            </TocLink>
                                        </li>
                                        <li className="mb-2">
                                            <TocLink>
                                                <a href="#introducao">2. Introdução</a>
                                            </TocLink>
                                        </li>
                                        <li className="mb-2">
                                            <TocLink>
                                                <a href="#informacoes">3. Informações tratadas</a>
                                            </TocLink>
                                        </li>
                                        <li className="mb-2">
                                            <TocLink>
                                                <a href="#dados-usuario">4. Dados fornecidos pelo Usuário</a>
                                            </TocLink>
                                        </li>
                                        <li className="mb-2">
                                            <TocLink>
                                                <a href="#coleta-automatica">5. Coleta automática</a>
                                            </TocLink>
                                        </li>
                                        <li className="mb-2">
                                            <TocLink>
                                                <a href="#coleta-atendimentos">6. Coleta em atendimentos</a>
                                            </TocLink>
                                        </li>
                                        <li className="mb-2">
                                            <TocLink>
                                                <a href="#outras-finalidades">7. Outras finalidades</a>
                                            </TocLink>
                                        </li>
                                        <li className="mb-2">
                                            <TocLink>
                                                <a href="#dados-sensiveis">8. Dados sensíveis</a>
                                            </TocLink>
                                        </li>
                                        <li className="mb-2">
                                            <TocLink>
                                                <a href="#tratamento-dados">9. Outras formas de tratamento</a>
                                            </TocLink>
                                        </li>
                                        <li className="mb-2">
                                            <TocLink>
                                                <a href="#regularidade">10. Regularidade da atividade</a>
                                            </TocLink>
                                        </li>
                                        <li className="mb-2">
                                            <TocLink>
                                                <a href="#compartilhamento">11. Compartilhamento de dados</a>
                                            </TocLink>
                                        </li>
                                        <li className="mb-2">
                                            <TocLink>
                                                <a href="#seguranca">12. Segurança dos dados</a>
                                            </TocLink>
                                        </li>
                                        <li className="mb-2">
                                            <TocLink>
                                                <a href="#armazenamento">13. Armazenamento</a>
                                            </TocLink>
                                        </li>
                                        <li className="mb-2">
                                            <TocLink>
                                                <a href="#direitos">14. Direitos do Titular</a>
                                            </TocLink>
                                        </li>
                                        <li className="mb-2">
                                            <TocLink>
                                                <a href="#cookies">15. Cookies</a>
                                            </TocLink>
                                        </li>
                                        
                                        <li className="mb-2">
                                            <TocLink>
                                                <a href="#links">17. Links</a>
                                            </TocLink>
                                        </li>
                                        <li className="mb-2">
                                            <TocLink>
                                                <a href="#dpo">16. Encarregado de proteção de dados (DPO) </a>
                                            </TocLink>
                                        </li>
                                    </ul>
                                </nav>
                            </TocSticky>
                        </PrivacySection>
                    </div>
                    <div className="col-lg-9">
                        <PrivacySectionContent id="glossario">
                            <div>
                                <h2>1. Glossário</h2>
                            </div>
                            <p>
                                Visando orientar os Clientes e Usuários dos serviços do Grupo Cereal e leitores deste aviso de privacidade, indicamos
                                abaixo um breve glossário acerca dos principais termos utilizados relacionados à Lei Geral de Proteção de Dados
                                Pessoais (LGPD) e seus significados:
                            </p>
                            <div className="accordion" id="glossarioAccordion">
                                <div className="accordion-item">
                                    <h2 className="">
                                        <button
                                            className="accordion-button collapsed py-1 bg-transparent shadow-none"
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#term1"
                                            aria-expanded="false"
                                        >
                                            Autoridade Nacional de Proteção de Dados Pessoais
                                        </button>
                                    </h2>
                                    <div id="term1" className="accordion-collapse collapse" data-bs-parent="#glossarioAccordion">
                                        <div className="accordion-body">
                                            É um órgão independente, mas subordinado à administração pública, e responsável pela aplicação e
                                            fiscalização do cumprimento da LGPD em todo o território nacional.
                                        </div>
                                    </div>
                                </div>
                                <div className="accordion-item"></div>

                                <div className="accordion-item">
                                    <h2 className="">
                                        <button
                                            className="accordion-button collapsed py-1 bg-transparent shadow-none"
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#term2"
                                            aria-expanded="false"
                                        >
                                            Agente de Tratamento
                                        </button>
                                    </h2>
                                    <div id="term2" className="accordion-collapse collapse" data-bs-parent="#glossarioAccordion">
                                        <div className="accordion-body">Pode ser o controlador ou o operador de dados pessoais.</div>
                                    </div>
                                </div>

                                <div className="accordion-item">
                                    <h2 className="">
                                        <button
                                            className="accordion-button collapsed py-1 bg-transparent shadow-none"
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#term3"
                                            aria-expanded="false"
                                        >
                                            Consentimento
                                        </button>
                                    </h2>
                                    <div id="term3" className="accordion-collapse collapse" data-bs-parent="#glossarioAccordion">
                                        <div className="accordion-body">
                                            Manifestação livre, informada e inequívoca, pela qual o titular concorda com o tratamento de seus dados
                                            pessoais para uma finalidade determinada.
                                        </div>
                                    </div>
                                </div>

                                <div className="accordion-item">
                                    <h2 className="">
                                        <button
                                            className="accordion-button collapsed py-1 bg-transparent shadow-none"
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#term4"
                                            aria-expanded="false"
                                        >
                                            Cookies
                                        </button>
                                    </h2>
                                    <div id="term4" className="accordion-collapse collapse" data-bs-parent="#glossarioAccordion">
                                        <div className="accordion-body">
                                            Os cookies de navegação são dados de referência que são coletados e armazenados pelos sites sobre a
                                            preferência de navegação do usuário, podendo conter dados de localidade, interação de conteúdo,
                                            publicidade, análise de performance e sessão.
                                        </div>
                                    </div>
                                </div>

                                <div className="accordion-item">
                                    <h2 className="">
                                        <button
                                            className="accordion-button collapsed py-1 bg-transparent shadow-none"
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#term5"
                                            aria-expanded="false"
                                        >
                                            Controlador
                                        </button>
                                    </h2>
                                    <div id="term5" className="accordion-collapse collapse" data-bs-parent="#glossarioAccordion">
                                        <div className="accordion-body">
                                            Pessoa física ou jurídica, de direito público ou privado, a quem competem as decisões referentes ao
                                            tratamento de dados pessoais.
                                        </div>
                                    </div>
                                </div>

                                <div className="accordion-item">
                                    <h2 className="">
                                        <button
                                            className="accordion-button collapsed py-1 bg-transparent shadow-none"
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#term6"
                                            aria-expanded="false"
                                        >
                                            Dado anonimizado
                                        </button>
                                    </h2>
                                    <div id="term6" className="accordion-collapse collapse" data-bs-parent="#glossarioAccordion">
                                        <div className="accordion-body">
                                            Dado relativo ao titular que não possa ser identificado, considerando a utilização de meios técnicos
                                            razoáveis e disponíveis na ocasião de seu tratamento.
                                        </div>
                                    </div>
                                </div>

                                <div className="accordion-item">
                                    <h2 className="">
                                        <button
                                            className="accordion-button collapsed py-1 bg-transparent shadow-none"
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#term7"
                                            aria-expanded="false"
                                        >
                                            Dado pessoal
                                        </button>
                                    </h2>
                                    <div id="term7" className="accordion-collapse collapse" data-bs-parent="#glossarioAccordion">
                                        <div className="accordion-body">
                                            Informação relacionada a uma pessoa física identificada ou identificável, que possa permitir a
                                            identificação de uma pessoa física ou que, identificada a pessoa, o dado possa ser associado à ela,
                                            revelando característica a seu respeito, como por exemplo,: seu nome, CPF, RG, endereço, telefone, e-mail
                                            entre outros;
                                        </div>
                                    </div>
                                </div>

                                <div className="accordion-item">
                                    <h2 className="">
                                        <button
                                            className="accordion-button collapsed py-1 bg-transparent shadow-none"
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#term8"
                                            aria-expanded="false"
                                        >
                                            Dado pessoal de criança e de adolescente
                                        </button>
                                    </h2>
                                    <div id="term8" className="accordion-collapse collapse" data-bs-parent="#glossarioAccordion">
                                        <div className="accordion-body">
                                            O Estatuto da Criança e do Adolescente (ECA) define como criança a pessoa até 12 (doze) anos de idade
                                            incompletos e adolescente aquela entre 12 (doze) e 18 (dezoito) anos de idade. A LGPD estabelece regras
                                            específicas para tratamento destes dados pessoais, sendo conferido a eles uma maior proteção.
                                        </div>
                                    </div>
                                </div>

                                <div className="accordion-item">
                                    <h2 className="">
                                        <button
                                            className="accordion-button collapsed py-1 bg-transparent shadow-none"
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#term9"
                                            aria-expanded="false"
                                        >
                                            Dado pessoal sensível
                                        </button>
                                    </h2>
                                    <div id="term9" className="accordion-collapse collapse" data-bs-parent="#glossarioAccordion">
                                        <div className="accordion-body">
                                            A LGPD apresenta uma definição específica de quais dados são considerados sensíveis, sendo eles: Dado
                                            pessoal sobre origem racial ou étnica, convicção religiosa, opinião pública, filiação a sindicato ou a
                                            organização de caráter religioso, filosófico ou político, dado referente à saúde ou à vida sexual, dado
                                            genético ou biométrico quando vinculado a uma pessoa física.
                                        </div>
                                    </div>
                                </div>

                                <div className="accordion-item">
                                    <h2 className="">
                                        <button
                                            className="accordion-button collapsed py-1 bg-transparent shadow-none"
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#term10"
                                            aria-expanded="false"
                                        >
                                            Encarregado de proteção de dados (Data Protection Officer - DPO)
                                        </button>
                                    </h2>
                                    <div id="term10" className="accordion-collapse collapse" data-bs-parent="#glossarioAccordion">
                                        <div className="accordion-body">
                                            Pessoa indicada pelo agente de tratamento (controlador ou operador) para atuar como canal de comunicação
                                            entre o Controlador, os Titulares dos Dados e a Autoridade Nacional de Proteção de Dados (ANPD). É ao
                                            encarregado que o titular de dados deve direcionar toda e qualquer dúvida ou requisição que tenha acerca
                                            do tratamento de seus dados pessoais.
                                        </div>
                                    </div>
                                </div>

                                <div className="accordion-item">
                                    <h2 className="">
                                        <button
                                            className="accordion-button collapsed py-1 bg-transparent shadow-none"
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#term11"
                                            aria-expanded="false"
                                        >
                                            Operador
                                        </button>
                                    </h2>
                                    <div id="term11" className="accordion-collapse collapse" data-bs-parent="#glossarioAccordion">
                                        <div className="accordion-body">
                                            Pessoa física ou jurídica, de direito público ou privado, que realiza o tratamento de dados pessoais em
                                            nome do Controlador.
                                        </div>
                                    </div>
                                </div>

                                <div className="accordion-item">
                                    <h2 className="">
                                        <button
                                            className="accordion-button collapsed py-1 bg-transparent shadow-none"
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#term12"
                                            aria-expanded="false"
                                        >
                                            Titular de dados
                                        </button>
                                    </h2>
                                    <div id="term12" className="accordion-collapse collapse" data-bs-parent="#glossarioAccordion">
                                        <div className="accordion-body">
                                            Pessoa física a quem se referem os dados pessoais que são objeto do tratamento. É o proprietário dos dados
                                            pessoais.
                                        </div>
                                    </div>
                                </div>

                                <div className="accordion-item">
                                    <h2 className="">
                                        <button
                                            className="accordion-button collapsed py-1 bg-transparent shadow-none"
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#term13"
                                            aria-expanded="false"
                                        >
                                            Transferência internacional de dados
                                        </button>
                                    </h2>
                                    <div id="term13" className="accordion-collapse collapse" data-bs-parent="#glossarioAccordion">
                                        <div className="accordion-body">
                                            Transferência de dados pessoais para país estrangeiro ou organismo internacional do qual o país seja
                                            membro.
                                        </div>
                                    </div>
                                </div>

                                <div className="accordion-item">
                                    <h2 className="">
                                        <button
                                            className="accordion-button collapsed py-1 bg-transparent shadow-none"
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#term14"
                                            aria-expanded="false"
                                        >
                                            Tratamento
                                        </button>
                                    </h2>
                                    <div id="term14" className="accordion-collapse collapse" data-bs-parent="#glossarioAccordion">
                                        <div className="accordion-body">
                                            É qualquer atividade que seja realizada com dados pessoais, como por exemplo a coleta, produção, recepção,
                                            classificação, utilização, acesso, reprodução, transmissão, distribuição, processamento, arquivamento,
                                            armazenamento, eliminação, avaliação ou controle da informação, modificação, comunicação, transferência,
                                            difusão ou extração.
                                        </div>
                                    </div>
                                </div>

                                <div className="accordion-item">
                                    <h2 className="">
                                        <button
                                            className="accordion-button collapsed py-1 bg-transparent shadow-none"
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#term15"
                                            aria-expanded="false"
                                        >
                                            Usuário
                                        </button>
                                    </h2>
                                    <div id="term15" className="accordion-collapse collapse" data-bs-parent="#glossarioAccordion">
                                        <div className="accordion-body">
                                            Toda pessoa que acesse e/ou faça o uso dos sites, portais de atendimento, serviços e produtos do Grupo
                                            Cereal.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </PrivacySectionContent>
                        <PrivacySectionContent id="introducao">
                            <div>
                                <h2>2. Introdução</h2>
                            </div>
                            <p>
                                O Grupo Cereal trata como prioridade a proteção dos dados de seus clientes e usuários de seus serviços, reforçando o
                                compromisso da organização com a privacidade e segurança dos dados coletados em serviços interativos oferecidos no
                                site e outros meios de comunicação.
                            </p>
                            <p>
                                Assim, foi desenvolvido o presente Aviso de Privacidade, documento que está de acordo com as regras estabelecidas pela
                                LGPD e que demonstra o compromisso do Grupo Cereal com a privacidade, discorrendo especialmente sobre: a coleta dos
                                dados pessoais e suas finalidades, o compartilhamento, medidas de segurança, armazenamento, quais são os seus direitos
                                como titular de dados pessoais e como você poderá exercê-los.
                            </p>
                            <p>
                            Contudo, cumpre destacar que este Aviso de Privacidade é apenas um dos meios pelos quais o Grupo Cereal busca estar em conformidade
                             com as normas de privacidade e proteção de dados pessoais. Sendo assim, caso o titular tenha alguma dúvida não sanada por meio deste 
                             documento, o canal do Encarregado pelo Tratamento de Dados Pessoais (Data Protection Officer – DPO) está indicado ao final. 
                            </p>

                            
                        </PrivacySectionContent>
                        <PrivacySectionContent id="informacoes">
                            <div>
                                <h2>3. Informações tratadas pelo Grupo Cereal</h2>
                            </div>
                            <p>
                                O Grupo Cereal poderá coletar as informações inseridas ativamente por você: "Usuário", no momento do contato ou
                                cadastro, por meio do preenchimento do formulário de contato, quanto do fornecimento de dados para serviços de
                                terceiros integrados com o Grupo Cereal e, ainda, informações coletadas automaticamente ao utilizar nossos serviços.
                                Há, assim, o tratamento dos dados pessoais: (i) fornecidos pelo próprio Usuário e (ii) aqueles coletados
                                automaticamente pelo Grupo Cereal.
                            </p>
                            <p>
                                Importante reforçar que o Grupo Cereal somente utiliza as informações necessárias para atingir a finalidade para a
                                qual elas foram coletadas.
                            </p>
                            <p>As especificações sobre o tratamento dos dados e suas finalidades podem ser verificadas abaixo:</p>
                        </PrivacySectionContent>
                        <PrivacySectionContent id="dados-usuario">
                            <div>
                                <h2>4. Dados Pessoais fornecidos pelo Usuário</h2>
                            </div>
                            <p>
                                O Grupo Cereal coleta todos os dados pessoais inseridos ou encaminhados ativamente pelo usuário ao contatar ou se
                                cadastrar em nosso portal. São eles:
                            </p>
                            <h3>Quando o titular utiliza o website do Grupo Cereal, os seguintes dados pessoais são coletados:</h3>
                            <div className="table-responsive mt-4">
                                <table className="table table-hover align-middle">
                                    <thead className="table-dark">
                                        <tr>
                                            <th scope="col">Canal de Coleta</th>
                                            <th scope="col">Finalidade</th>
                                            <th scope="col">Dados Coletados</th>
                                            <th scope="col">Origem</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Trabalhe Conosco</td>
                                            <td>Permitir a participação do titular em processos seletivos da empresa</td>
                                            <td>
                                                Nome completo, data de nascimento, telefone pessoal, telefone para recados, e-mail pessoal, nível de
                                                escolaridade, se é pessoa com deficiência, qual deficiência e se precisa de assistência especial,
                                                cidade, estado, última empresa em que trabalhou, data de saída da empresa, último salário, histórico
                                                profissional, pretensão salarial, disponibilidade de horários e eventuais outros dados constantes no
                                                currículo anexado.
                                            </td>
                                            <td>Próprio titular</td>
                                        </tr>
                                        <tr>
                                            <td>E-mail de contato do site</td>
                                            <td>Atendimento da solicitação do titular</td>
                                            <td>Nome, telefone, e-mail e eventuais outros dados informados pelo titular na mensagem a ser enviada</td>
                                            <td>Próprio titular</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </PrivacySectionContent>
                        <PrivacySectionContent id="coleta-automatica">
                            <div>
                                <h2>5. Coleta automática de dados</h2>
                            </div>
                            <p>
                                Visando o fornecimento de melhorias na experiência dos Clientes e Usuários quanto ao uso dos serviços do Grupo Cereal,
                                há ainda a coleta de dados de forma automática, no ato do acesso ao nosso{" "}
                                <a href="https://www.grupocereal.com.br/" target="_blank" rel="noopener noreferrer">
                                    site
                                </a>
                                . Este tratamento de dados é feito utilizando ferramentas como os cookies, local shared objects, beacons, pixel tags e
                                formulários, nas condições abaixo:
                            </p>
                            <div className="table-responsive mt-4">
                                <table className="table table-hover align-middle">
                                    <thead className="table-dark">
                                        <tr>
                                            <th scope="col">Canal de coleta</th>
                                            <th scope="col">Finalidade</th>
                                            <th scope="col">Dados Coletados</th>
                                            <th scope="col">Origem</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Uso do site pelo Cliente ou Usuário</td>
                                            <td>Melhoria da experiência de navegação</td>
                                            <td>
                                                Características do dispositivo de acesso e do navegador, informações do navegador e do IP (origem,
                                                data e hora), informações sobre cliques e páginas acessadas, termos de procura utilizados em caixas de
                                                busca e outros dados aplicáveis conforme o acesso
                                            </td>
                                            <td>Coleta automática ao acessar os sites e portais de interação.</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </PrivacySectionContent>
                        <PrivacySectionContent id="coleta-atendimentos">
                            <div>
                                <h2>6. Coleta de dados em atendimentos</h2>
                            </div>
                            <p>
                                O Grupo Cereal poderá ainda tratar dados pessoais diversos no momento da realização de atendimentos por meio de
                                contato telefônico, por chats em seus perfis oficiais nas redes sociais ou até mesmo presenciais. No momento do
                                atendimento, serão informados os dados pessoais necessários para prosseguimento com a solicitação. Sendo eles:
                            </p>

                            <div className="table-responsive mt-4">
                                <table className="table table-hover align-middle">
                                    <thead className="table-dark">
                                        <tr>
                                            <th scope="col">Canal de coleta</th>
                                            <th scope="col">Finalidade</th>
                                            <th scope="col">Dados Coletados</th>
                                            <th scope="col">Origem</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Atendimento telefônico ou presencial</td>
                                            <td>Canal direcionado ao titular para contato em geral</td>
                                            <td>Nome, telefone e eventuais dados necessários para o atingimento da finalidade</td>
                                            <td>Próprio titular</td>
                                        </tr>
                                    </tbody>
                                </table>
                                </div>
                                <p className="mt-4">
                                Reforçamos o nosso compromisso com os princípios da finalidade, necessidade e adequação contidos na LGPD sendo
                                utilizados apenas aqueles dados pessoais estritamente necessários para o alcance das finalidades declaradas na coleta
                                dos dados. Dados excedentes e desnecessários não serão mantidos pelo Grupo Cereal, em conformidade com o que
                                estabelece a legislação vigente.
                            </p>
                        </PrivacySectionContent>
                        <PrivacySectionContent id="outras-finalidades">
                            <div>
                                <h2>9. Outras finalidades</h2>
                            </div>
                            <p>Ainda, poderemos tratar os dados pessoais coletados para os seguintes fins:</p>
                            <div className="table-responsive mt-4">
                                <table className="table table-hover align-middle">
                                    <thead className="table-dark">
                                        <tr>
                                            <th scope="col">Canal de coleta</th>
                                            <th scope="col">Finalidade</th>
                                            <th scope="col">Dados Coletados</th>
                                            <th scope="col">Origem</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Cumprimento do Contrato de Prestação de Serviços eventualmente firmado</td>
                                            <td>
                                                Em geral, cumprir as obrigações e realizar as atividades estabelecidas nas relações firmadas com os
                                                clientes, ou processar os dados previamente para viabilizar a relação contratual. Pode variar conforme
                                                a obrigação
                                            </td>
                                            <td>
                                                Dados gerais de qualificação, como nome, CPF, RG, endereço, telefone, e-mail, dados financeiros entre
                                                outras informações a depender do caso.
                                            </td>
                                            <td>Próprio titular</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                Cumprimento de obrigações legais as quais o Grupo Cereal está submetido em função da atividade
                                                realizada, como por exemplo o armazenamento de registros de conexão
                                            </td>
                                            <td>Atendimento das obrigações decorrentes da legislação</td>
                                            <td>Endereço IP, data, hora e duração do acesso.</td>
                                            <td>Coletado automaticamente quando do acesso.</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </PrivacySectionContent>
                        <PrivacySectionContent id="dados-sensiveis">
                            <div>
                                <h2>7. Dados pessoais de crianças e adolescentes e dados sensíveis</h2>
                            </div>
                            <p>
                                Nas suas atividades usuais, o Grupo Cereal não tratará dados sensíveis. Também não haverá nas rotinas comuns
                                realizadas com dados de Usuários ou Clientes o tratamento de dados de crianças ou adolescentes. Entretanto, havendo
                                uma situação em que o uso destas categorias de dados se mostrar necessário, serão adotadas todas as medidas legalmente
                                exigidas para sua utilização.
                            </p>
                        </PrivacySectionContent>
                        <PrivacySectionContent id="tratamento-dados">
                            <div>
                                <h2>11. Outras formas de tratamento de dados</h2>
                            </div>
                            <p>Abaixo listamos outras situações em que o Grupo Cereal poderá tratar dados pessoais:</p>
                            <div className="table-responsive mt-4">
                                <table className="table table-hover align-middle">
                                    <thead className="table-dark">
                                        <tr>
                                            <th scope="col">Canal de Coleta</th>
                                            <th scope="col">Finalidade</th>
                                            <th scope="col">Dados Coletados</th>
                                            <th scope="col">Origem</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                Atendimento de obrigações diversas de contratos ou processamento de dados para viabilizar a
                                                contratação.
                                            </td>
                                            <td>
                                                Em geral, cumprir as obrigações e realizar as atividades estabelecidas nas relações firmadas com
                                                Clientes, ou processar os dados previamente para viabilizar a relação contratual. Pode variar conforme
                                                a obrigação.
                                            </td>
                                            <td>
                                                Dados gerais de qualificação, como nome, CPF, RG, estado civil, nacionalidade, endereço, telefone,
                                                e-mail, dados financeiros entre outras informações a depender do caso.
                                            </td>
                                            <td>Próprio titular.</td>
                                        </tr>
                                        <tr>
                                            <td>Uso de informações pessoais em processos judiciais, administrativos ou arbitrais.</td>
                                            <td>Viabilizar a defesa dos direitos e/ou interesses do Grupo Cereal</td>
                                            <td>
                                                Dados gerais de qualificação, como nome, CPF, RG, estado civil, nacionalidade, endereço, telefone,
                                                e-mail, dados financeiros entre outras informações a depender do caso.
                                            </td>
                                            <td>Próprio titular.</td>
                                        </tr>
                                        <tr>
                                            <td>Coleta e armazenamento de informações de Clientes para atendimento de regramentos específicos.</td>
                                            <td>Cumprimento de obrigações legais ou regulatórias.</td>
                                            <td>
                                                Dados gerais de qualificação, como nome, CPF, RG, estado civil, nacionalidade, endereço, telefone,
                                                e-mail, dados financeiros entre outras informações a depender do caso.
                                            </td>
                                            <td>Próprio titular.</td>
                                        </tr>
                                        <tr>
                                            <td>Uso de dados de clientes para autenticações de acesso nos portais Grupo Cereal.</td>
                                            <td>Prevenção à fraude e garantia da segurança dos Clientes Grupo Cereal.</td>
                                            <td>Nome, e-mail e senha.</td>
                                            <td>Próprio titular.</td>
                                        </tr>
                                        <tr>
                                            <td>Consultas a serviços de proteção ao crédito.</td>
                                            <td>Garantir a segurança de eventuais transações em negociações com Usuários e Clientes.</td>
                                            <td>
                                                Dados gerais de qualificação, como nome, CPF, RG, estado civil, nacionalidade, endereço, telefone,
                                                e-mail, dados financeiros entre outras informações a depender do caso.
                                            </td>
                                            <td>Próprio titular.</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </PrivacySectionContent>
                        <PrivacySectionContent id="regularidade">
                            <div>
                                <h2>8. Regularidade da atividade de tratamento</h2>
                            </div>
                            <p>
                                O Grupo Cereal sempre observará os deveres e princípios estabelecidos na LGPD para realizar suas atividades de
                                tratamento de dados. Isso inclui:
                            </p>
                            <ul className="list-group mt-3">
                                <li className="list-group-item">
                                    Coletar o consentimento do Titular, quando ele for legalmente exigido, respeitando ainda a finalidade para a qual
                                    ele foi concedido;
                                </li>
                                <li className="list-group-item">
                                    Quando o tratamento de dados for realizado com base no legítimo interesse, realizá-lo de forma balanceada,
                                    buscando o equilíbrio entre a expectativa do Titular e o legítimo interesse do Grupo Cereal.
                                </li>
                                <li className="list-group-item">
                                    Utilizar as informações pessoais estritamente necessárias para realização das atividades, não coletando dados
                                    desnecessários ou em excesso.
                                </li>
                            </ul>
                        </PrivacySectionContent>
                        <PrivacySectionContent id="compartilhamento">
                            <div>
                                <h2>9. Compartilhamento de dados pessoais com terceiros</h2>
                            </div>
                            <p>
                                Como já destacado ao longo deste documento, o Grupo Cereal se preocupa com a privacidade e a proteção dos dados
                                tratados e somente compartilhará essas informações com terceiros caso seja necessário para cumprir com finalidades
                                pré-determinadas. Por essa razão, os dados pessoais poderão ser compartilhados com terceiros apenas quando for:
                            </p>

                            <ul className="list-group mt-3">
                                <li className="list-group-item">
                                    Com empresas clientes, parceiras e fornecedores no desenvolvimento e prestação de serviços voltados a você ou sua
                                    empresa;
                                </li>
                                <li className="list-group-item">
                                    Com autoridades, entidades governamentais ou outros terceiros institucionais, para a proteção dos interesses do
                                    Grupo Cereal em qualquer tipo de conflito, incluindo ações judiciais e processos administrativos;
                                </li>
                                <li className="list-group-item">
                                    Entes e órgãos da administração pública e autoridades em geral, quando exigido por legislação ou regulamento;
                                </li>
                                <li className="list-group-item">
                                    No caso de transações e alterações societárias envolvendo o Grupo Cereal, em que a transferência das informações
                                    será necessária para a continuidade dos serviços;
                                </li>
                                <li className="list-group-item">
                                    Mediante ordem judicial ou pelo requerimento de autoridades administrativas que detenham competência legal para a
                                    sua requisição;
                                </li>
                                <li className="list-group-item">Com instituições financeiras, para análise e proteção de crédito.</li>
                            </ul>

                            <p className="mt-4">
                                Caso haja necessidade de realizar a transferência de dados para partes que estejam localizadas fora do território
                                nacional, o Grupo Cereal priorizará países que possuam nível equivalente de proteção de dados, conduzindo a
                                transferência de acordo com as condições previstas na LGPD.
                            </p>
                        </PrivacySectionContent>
                        <PrivacySectionContent id="seguranca">
                            <div>
                                <h2>10. Segurança dos dados pessoais</h2>
                            </div>
                            <p>
                                O Grupo Cereal adota diversas medidas técnicas, administrativas e organizacionais para a proteção dos dados pessoais,
                                mantendo um nível de segurança compatível com as informações coletadas e as atividades realizadas.
                            </p>
                            <p>Como exemplo, são citadas abaixo:</p>
                            <ul className="list-group mt-3">
                                <li className="list-group-item">
                                    O Grupo Cereal implementou e mantém um programa de privacidade, com uma equipe designada, para monitorar as
                                    atividades de tratamento de dados e garantir a segurança das informações. A equipe é responsável por manter a
                                    empresa atualizada em termos de privacidade;
                                </li>
                                <li className="list-group-item">
                                    Os dados pessoais são armazenados em servidores protegidos por salvaguardas técnicas, restrições e limitações de
                                    acesso eletrônico e físico. Isso garante a confidencialidade, integridade e disponibilidade das informações;
                                </li>
                                <li className="list-group-item">
                                    Utiliza os mais recentes métodos e equipamentos disponíveis no mercado para criptografar suas comunicações, quando
                                    necessário;
                                </li>
                                <li className="list-group-item">
                                    O acesso às informações é estritamente limitado aos funcionários envolvidos nas atividades de tratamento de dados.
                                    Esses funcionários são devidamente treinados sobre a importância do cuidado e sigilo no tratamento dos dados.
                                    O não cumprimento dessas diretrizes acarretará nas medidas contratuais e legais cabíveis; 
                                </li>
                                <li className="list-group-item">
                                São implementadas políticas de senhas fortes e com alterações periódicas, além da realização de backups dos dados
                                 regularmente. Essas medidas visam fortalecer a segurança e disponibilidade das informações; 
                                </li>
                                <li className="list-group-item">
                                São adotadas medidas de segurança física, como o uso de sistemas de vigilância, monitoramento, 
                                alarmes e acesso restrito com identificação prévia nas instalações do Grupo Cereal; 
                                </li>
                                <li className="list-group-item">
                                São adotadas medidas de proteção contra acessos indevidos aos equipamentos, sistemas e redes da empresa, 
                                incluindo o uso de softwares antimalware e antivírus, bem como a conscientização dos colaboradores sobre essas medidas e o uso das ferramentas de trabalho. 
                                </li>
                                <p>
                                Embora o Grupo Cereal tome medidas contínuas para proteger as informações, é importante ressaltar que não existe segurança absoluta quando se trata do uso 
                                de informações pessoais. Portanto, não podemos garantir que incidentes de segurança não ocorrerão. 
                            </p>
                            <p>
                            Caso ocorra algum incidente de segurança envolvendo dados pessoais, o Grupo Cereal assegura que agirá prontamente para reduzir os riscos e minimizar 
                            os danos resultantes desse incidente.  
                            </p>
                            </ul>
                        </PrivacySectionContent>
                        <PrivacySectionContent id="armazenamento">
                            <div>
                                <h2>11. Armazenamento de dados</h2>
                            </div>
                            <p>
                            Os dados pessoais serão armazenados pelo tempo necessário para alcançar as finalidades de tratamento mencionadas neste Aviso de Privacidade. 
                            Isso pode incluir o armazenamento de informações para cumprir obrigações legais ou regulatórias, bem como para proteger os interesses do Grupo
                             Cereal em processos judiciais, administrativos ou arbitrais. Nesses casos, o Grupo Cereal pode reter tais informações, mesmo se o titular 
                             solicitar sua exclusão. 
                            </p>
                            <p>
                            No entanto, se o processamento dos dados for baseado no consentimento, as informações serão excluídas a partir do momento em que o titular 
                            fizer a solicitação. 
                            </p>
                            <p>
                            Caso não haja uma finalidade específica para manter os dados, eles serão devidamente eliminados de maneira segura ou, quando aplicável, 
                            anonimizados, para serem mantidos apenas para fins de registros históricos pelo Grupo Cereal. 
                            </p>
                            <p>
                            Ainda, informamos que o término do tratamento dos dados pessoais ocorrerá após o fim do período de tratamento informado ao titular ou mediante 
                            determinação da Autoridade Nacional de Proteção de Dados (ANPD), quando houver violação ao disposto na LGPD. 
                            </p>
                        </PrivacySectionContent>
                        <PrivacySectionContent id="direitos">
                            <div>
                                <h2>12. Direitos do Titular de dados</h2>
                            </div>
                            <p>
                            O Grupo Cereal respeita os direitos dos titulares definidos na LGPD, que incluem: 
                            </p>
                            <ul className="list-group mt-3">
                                <li className="list-group-item">Confirmação da existência de tratamento; </li>
                                <li className="list-group-item">Acesso aos dados; </li>
                                <li className="list-group-item">Correção de dados; </li>
                                <li className="list-group-item">Anonimização, bloqueio ou eliminação de dados;</li>
                                <li className="list-group-item">Portabilidade;</li>
                                <li className="list-group-item">Revogação do consentimento; </li>
                                <li className="list-group-item">Informações sobre compartilhamentos de dados pessoais;</li>
                                <li className="list-group-item">Possibilidade de não fornecer e consequências do não fornecimento do consentimento; </li>
                                <li className="list-group-item">Revisão das decisões automatizadas.  </li>
                            </ul>
                            <p>
                            O Grupo Cereal se empenha para responder de forma rápida e objetiva, lembrando que prazos são definidos conforme 
                            complexibilidade de cada demanda à ser analisada.  
                            </p>
                            <p>
                            Ainda, para que o Grupo Cereal possa atender às requisições feitas pelo titular e para garantir a segurança dos dados pessoais, 
                            é possível que seja necessário solicitar alguns documentos e/ou informações para confirmar a identidade do solicitante e a 
                            autenticidade da solicitação. 
                            </p>
                            <p>
                            Além disso, destacamos que o Grupo Cereal poderá recusar o atendimento de certas solicitações do titular. Por exemplo, 
                            se a identidade do solicitante não puder ser comprovada ou se a exclusão de informações for solicitada e o Grupo Cereal 
                            tiver a obrigação legal ou regulatória de mantê-las, o titular será informado dessa situação ao receber a resposta. 
                            </p>
                        </PrivacySectionContent>
                        <PrivacySectionContent id="cookies">
                            <div>
                                <h2>13. Cookies</h2>
                            </div>
                            <p>
                            Os cookies são arquivos pequenos que contêm dados trocados entre um dispositivo, como um celular ou computador,
                             e um site da web. Eles são armazenados com o propósito de aprimorar a experiência do usuário ou cliente no site.
                              Para obter mais informações, recomendamos que acesse nossa Política de Cookies. 
                            </p>
                        </PrivacySectionContent>
                        <PrivacySectionContent id="links">
                            <div>
                                <h2>14. Links para outros aplicativos e sites</h2>
                            </div>
                            <p>
                            Nossos serviços podem conter links para sites de terceiros, que não estão sujeitos às disposições deste Aviso de Privacidade. 
                            É recomendado que os usuários consultem as políticas de terceiros antes de interagir com os seus sites. 
                            </p>
                        </PrivacySectionContent>
                        <PrivacySectionContent id="dpo">
                            <div>
                                <h2>15. Encarregado de proteção de dados (DPO)</h2>
                            </div>
                            <p>
                            O encarregado de proteção de dados é o profissional responsável por receber e processar as solicitações dos usuários e 
                            clientes do Grupo Cereal. Caso você precise falar sobre seus dados pessoais, o Sr. Galeno José Costa e Silva, encarregado 
                            de dados do Grupo Cereal pode ser contatado pelo <a href="https://lgpdgrupocereal.nuvemx.com.br/">Portal de Privacidade</a> ou pelo e-mail dpo@grupocereal.com.br. 
                            </p>
                        </PrivacySectionContent>
                    </div>
                </div>
            </div>
        </AvisoPrivacidadeBody>
    );
}
